const flats = document.querySelector('.flats');

if (flats) {
    const btn = document.querySelector('#flats-btn');

    const roomsCheckboxes = document.querySelectorAll('.rooms-checkbox');
    const areaInputs = document.querySelectorAll('.area-input');
    const rentInputs = document.querySelectorAll('.rent-input');
    const typeCheckboxes = document.querySelectorAll('.type-checkbox');
    const noFlats = document.querySelector('#no-flats');

    const flatsItems = document.querySelectorAll('.flats__item');
    const filtersOpeners = document.querySelectorAll('.flats__filterOpener');

    filtersOpeners.forEach((opener) => {
        opener.addEventListener('click', () => {
            opener.parentElement.classList.toggle('flats__filter--opened');
        });
    });

    btn.addEventListener('click', () => {
        filtersOpeners.forEach((opener) => {
            opener.parentElement.classList.remove('flats__filter--opened');
        });

        btn.classList.remove('flats__btn--filtered');

        noFlats.style.display = 'none';

        const filters = {
            rooms: {
                filtered: false,
                values: [],
            },
            area: {
                filtered: false,
                min: 0,
                max: 999999999,
            },
            type: {
                filtered: false,
                values: [],
            },
            rent: {
                min: 0,
                filtered: false,
                max: 999999999,
            },
        };

        roomsCheckboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                filters.rooms.values.push(checkbox.value);
                filters.rooms.filtered = true;
            }
        });

        typeCheckboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                filters.type.values.push(checkbox.value);
                filters.type.filtered = true;
            }
        });

        areaInputs.forEach((input, i) => {
            if (input.value.length > 0) {
                i === 0 ? (filters.area.min = input.value) : (filters.area.max = input.value);
                filters.area.filtered = true;
            }
        });

        rentInputs.forEach((input, i) => {
            if (input.value.length > 0) {
                i === 0 ? (filters.rent.min = input.value) : (filters.rent.max = input.value);
                filters.rent.filtered = true;
            }
        });

        let hiddenFlats = 0;

        flatsItems.forEach((flat) => {
            flat.style.display = 'table-row';

            const flatData = {
                rooms: flat.dataset.rooms,
                area: flat.dataset.area,
                type: flat.dataset.type,
                rent: flat.dataset.rent,
            };

            const filtersCompatibility = [];

            if (filters.rooms.filtered)
                filtersCompatibility.push(
                    filters.rooms.values.some((value) => value === flatData.rooms),
                );

            if (filters.type.filtered)
                filtersCompatibility.push(
                    filters.type.values.some((value) => value === flatData.type),
                );

            if (Number(filters.area.min) > Number(filters.area.max))
                filters.area.min = filters.area.max;

            if (
                Number(flatData.area) >= Number(filters.area.min) &&
                Number(flatData.area) <= Number(filters.area.max)
            ) {
                filtersCompatibility.push(true);
            } else {
                filtersCompatibility.push(false);
            }

            if (Number(filters.rent.min) > Number(filters.rent.max))
                filters.rent.min = filters.rent.max;

            if (
                Number(flatData.rent) >= Number(filters.rent.min) &&
                Number(flatData.rent) <= Number(filters.rent.max)
            ) {
                filtersCompatibility.push(true);
            } else {
                filtersCompatibility.push(false);
            }

            if (filtersCompatibility.length > 0) {
                if (filtersCompatibility.some((value) => value === false)) {
                    flat.style.display = 'none';
                    hiddenFlats++;
                }
            }
        });

        if (hiddenFlats === flatsItems.length) {
            noFlats.style.display = 'block';
        }

        Object.keys(filters).map(function (key, index) {
            if (filters[key].filtered) btn.classList.add('flats__btn--filtered');
        });
    });
}
